import * as actionTypes from './actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.ajaxCall, action) {
  let stack;
  let position;
  switch (action.type) {
    case actionTypes.ADD_TO_STACK_AJAX:
      stack = state.stack.slice();
      stack.push(action.payload);
      return { ...state, stack };
    case actionTypes.REMOVE_FROM_STACK_AJAX:
      stack = state.stack.slice();
      position = stack.findIndex(request => action.payload === request.id);
      if (position > -1) {
        stack.splice(position, 1);
      }
      return { ...state, stack };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/ajaxCall/reducer.js